export default [
  {
    path: '/breaking-lesson',
    component: () => import('./views/Index'),
    name: 'breaking-lesson',
    redirect: { name: 'breaking-lesson-list' },
    children: [
      {
        path: 'lessons',
        name: 'breaking-lesson-list',
        component: () => import('./views/List'),
        meta: {
          resource: 'content',
        },
      },
      {
        path: 'lessons/:lesson_id',
        name: 'breaking-lesson-detail',
        component: () => import('./views/Detail'),
        meta: {
          resource: 'content',
        },
      },
    ],
  },
]
